<template>
  <div class="order-detail-container">
    <!-- 按钮区域 - 使用flex布局使按钮左右分布 -->
    <div class="button-group">
      <button class="back-button" @click="goBack">
        <i class="back-icon">←</i> 返回
      </button>
      
      <!-- 退回按钮显示在右侧 -->
      <button class="withdraw-button" @click="withdrawOrder">
        退回订单
      </button>
    </div>
    
    <!-- 加载状态 -->
    <div v-if="loading" class="loading">加载中...</div>
    
    <!-- 错误提示 -->
    <div v-if="error" class="error">{{ error }}</div>
    
    <!-- 操作结果提示 -->
    <div v-if="message" class="message" :class="{ 'success': messageType === 'success', 'error': messageType === 'error' }">
      {{ message }}
    </div>
    
    <!-- 订单详情 -->
    <div v-if="!loading && !error" class="order-content">
      <!-- 订单信息编辑区域 -->
      <div class="order-form">
        <h2>订单信息</h2>
        <form>
          <div class="form-group">
            <label for="carNumber">车牌号:</label>
            <input type="text" id="carNumber" v-model="orderDetail.carNumber" readonly>
          </div>
          
          <div class="form-group">
            <label for="addr">地址:</label>
            <input type="text" id="addr" v-model="orderDetail.addr" readonly>
          </div>
          
          <div class="form-group">
            <label for="orderDate">订单日期:</label>
            <input type="date" id="orderDate" v-model="orderDetail.orderDate" readonly>
          </div>
          
          <div class="form-group">
            <label for="remark">备注:</label>
            <textarea id="remark" v-model="orderDetail.remark" readonly></textarea>
          </div>
          
          <div class="form-group">
            <label for="ownerName">货主姓名:</label>
            <input type="text" id="ownerName" v-model="orderDetail.ownerName">
          </div>
          
          <div class="form-group">
            <label for="driverName">司机姓名:</label>
            <input type="text" id="driverName" v-model="orderDetail.driverName" readonly>
          </div>
        </form>
		
		<el-button type="success" @click="saveOrder">保存</el-button>
      </div>
      
      <!-- 订单货物列表 -->
      <div class="order-items">
        <h2>货物清单</h2>
        <table class="items-table">
          <thead>
            <tr>
              <th>序号</th>
              <th>产品名称</th>
              <th>运费</th>
              <th>数量</th>
              <th>单位</th>
			  <th>下车</th>
              <th>场地</th>
              <th>匹配状态</th>
              <th>操作</th> <!-- 新增操作列 -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in orderItems" :key="item.itemId">
              <td>{{ index + 1 }}</td>
              <td>{{ item.productName }}</td>
              <td><input type="number" v-model="item.price" @input="calculateRowTotal(item)"></td>
              <td>{{ item.quantity }}</td>
              <td>{{ item.productUnit }}</td>
			  <td>{{ item.carry }}</td>
              <td>{{ item.ground }}</td>
              <td>
                <span 
                  class="status-tag" 
                  :class="{ 'matched': item.matched !== 0, 'unmatched': item.matched === 0 }"
                >
                  {{ item.matched === 0 ? '未对账' : '已对账' }}
                </span>
              </td>
              <td>
                <!-- 已修改：将按钮改为绿色 -->
                <el-button 
                  type="success" 
                  size="mini" 
                  @click="updateOrderItem(item)"
                  :disabled="item.updating"
                >
                  <template v-if="item.updating">更新中...</template>
                  <template v-else>保存</template>
                </el-button>
              </td>
            </tr>
            <!-- 运费总价行 -->
            <tr class="total-row">
              <td colspan="2"></td>
              <td class="grand-total">
                总运费: {{ calculateTotalPrice().toFixed(2) }}
              </td>
              <td colspan="5"></td> <!-- 调整colspan以适应新增列 -->
            </tr>
          </tbody>
        </table>
      </div>
	  <!-- 视频展示区域 -->
	  <div class="video-section" v-if="orderDetail.url">
	    <h2>相关视频</h2>
	    <video 
	      :src="orderDetail.url" 
	      controls 
	      class="order-video"
	      :alt="orderDetail.img"
	    >
	      您的浏览器不支持视频播放
	    </video>
	  </div>
    </div>
  </div>
</template>

<script>
import adminrequest from '@/utils/adminrequest'
import axios from 'axios'

export default {
  data() {
    return {
      orderId: this.$route.query.orderId,
      orderDetail: {},
      orderItems: [],
      loading: true,
      error: '',
      message: '',       // 操作结果消息
      messageType: ''    // 消息类型：success/error
    };
  },
  
  mounted() {
    // 获取订单详情
    this.getOrderDetail();
    // 获取订单货物数据
    this.getOrderItems();
  },
  
  methods: {
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    },
    
    // 退回订单
    async withdrawOrder() {
      // 确认操作
      if (!confirm('确定要退回此订单吗？')) {
        return;
      }
      
      try {
        // 显示加载状态
        this.loading = true;
        this.error = '';
        
        const options = {
          method: 'POST',
          url: '/admin/manage/order/withdraw',
          params: { 
            orderId: this.orderId  // 使用当前订单ID
          }
        };
        
        const response = await adminrequest.request(options);
        
        if (response.data.code === 200) {
          this.message = '订单已成功退回';
          this.messageType = 'success';
          
          // 刷新订单详情
          this.getOrderDetail();
          
          // 3秒后隐藏消息
          setTimeout(() => {
            this.message = '';
          }, 3000);
        } else {
          this.message = `退回失败: ${response.data.message}`;
          this.messageType = 'error';
        }
      } catch (err) {
        this.message = `操作失败: ${err.message}`;
        this.messageType = 'error';
        console.error('退回订单错误:', err);
      } finally {
        this.loading = false;
      }
    },
    
    // 保存订单信息
    async saveOrder() {
      try {
        // 显示加载状态
        this.loading = true;
        this.error = '';
        
        // 准备请求参数
        const options = {
          method: 'POST',
          url: '/admin/manage/order/updateOrder',
          data: {
            orderId: this.orderId,
            ownerName: this.orderDetail.ownerName
          }
        };
        
        const response = await adminrequest.request(options);
        
        if (response.data.code === 200) {
          this.message = '订单信息保存成功';
          this.messageType = 'success';
          
          // 3秒后隐藏消息
          setTimeout(() => {
            this.message = '';
          }, 3000);
        } else {
          this.message = `保存失败: ${response.data.message || '未知错误'}`;
          this.messageType = 'error';
        }
      } catch (err) {
        this.message = `保存失败: ${err.message}`;
        this.messageType = 'error';
        console.error('保存订单错误:', err);
      } finally {
        this.loading = false;
      }
    },
    
    // 更新单个货物的运费
    async updateOrderItem(item) {
      try {
        // 标记当前项目正在更新
        item.updating = true;
        this.error = '';
        
        // 准备请求参数
        const options = {
          method: 'POST',
          url: '/admin/manage/order/updateOrderItem',
          data: {
            itemId: item.itemId,
            price: Number(item.price) || 0
          }
        };
        
        const response = await adminrequest.request(options);
        
        if (response.data.code === 200) {
          // 已修改：更新成功后显示弹出提示
          this.$message({
            message: '货物运费更新成功',
            type: 'success',
            duration: 3000
          });
          
          // 更新总运费
          this.updateOrderTotalPrice();
        } else {
          this.$message({
            message: `更新失败: ${response.data.message || '未知错误'}`,
            type: 'error',
            duration: 3000
          });
        }
      } catch (err) {
        this.$message({
          message: `更新失败: ${err.message}`,
          type: 'error',
          duration: 3000
        });
        console.error('更新货物运费错误:', err);
      } finally {
        // 取消更新标记
        item.updating = false;
      }
    },
    
    async getOrderDetail() {
      try {
        const options = {
          method: 'GET',
          url: '/admin/manage/order/getOrderDetail',
          params: { 
            orderId: this.orderId 
          }
        };
        
        const response = await adminrequest.request(options);
        
        if (response.data.code === 200) {
          this.orderDetail = response.data.data;
        } else {
          this.error = `获取订单详情失败: ${response.data.message}`;
        }
      } catch (err) {
        this.error = `请求失败: ${err.message}`;
        console.error('获取订单详情错误:', err);
      } finally {
        this.loading = false;
      }
    },
    
    async getOrderItems() {
      try {
        const options = {
          method: 'GET',
          url: '/admin/manage/order/getOrderItem',
          params: {
            orderId: this.orderId
          }
        };
        
        const response = await adminrequest.request(options);
        
        if (response.data.code === 200) {
          this.orderItems = response.data.data;
          // 初始化价格为数字类型，并添加更新状态标记
          this.orderItems.forEach(item => {
            item.price = Number(item.price) || 0;
            item.updating = false; // 新增更新状态属性
          });
        } else {
          this.error = `获取订单货物失败: ${response.data.message}`;
        }
      } catch (err) {
        this.error = `请求失败: ${err.message}`;
        console.error('获取订单货物错误:', err);
      } finally {
        // 保持与getOrderDetail格式一致
      }
    },
    
    // 计算单行运费变化时触发
    calculateRowTotal(item) {
      // 确保运费为数字
      item.price = Number(item.price) || 0;
      // 更新订单总运费
      this.updateOrderTotalPrice();
    },
    
    // 计算所有货物运费总和
    calculateTotalPrice() {
      // 总运费 = 各货物运费之和
      return this.orderItems.reduce((total, item) => {
        const price = Number(item.price) || 0;
        return total + price;
      }, 0);
    },
    
    // 更新订单总运费
    updateOrderTotalPrice() {
      const totalFreight = this.calculateTotalPrice();
      // 订单总运费 = 所有货物运费总和
      this.orderDetail.totalPrice = totalFreight.toFixed(2);
    }
  },
  
  // 监听货物运费变化，更新总运费
  watch: {
    'orderItems': {
      deep: true,
      handler() {
        this.updateOrderTotalPrice();
      }
    }
  }
};
</script>

<style scoped>
.order-detail-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

/* 按钮组样式 - 使用space-between使按钮左右分布 */
.button-group {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* 返回按钮样式 */
.back-button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  transition: background-color 0.3s;
}

.back-button:hover {
  background-color: #0056b3;
}

/* 退回按钮样式 */
.withdraw-button {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  transition: background-color 0.3s;
}

.withdraw-button:hover {
  background-color: #bb2d3b;
}

.back-icon {
  margin-right: 6px;
}

h1, h2 {
  color: #333;
  margin-bottom: 20px;
}

.loading, .error, .message {
  text-align: center;
  padding: 20px;
  font-size: 18px;
  margin-bottom: 20px;
  border-radius: 4px;
}

.error {
  color: #dc3545;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
}

.message.success {
  color: #155724;
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
}

.message.error {
  color: #721c24;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
}

.video-section {
  margin-bottom: 40px;
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}

.order-video {
  width: 100%;
  max-width: 800px;
  height: auto;
  border-radius: 4px;
}

.order-form {
  margin-bottom: 40px;
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: inline-block;
  width: 120px;
  font-weight: bold;
  color: #555;
}

input, textarea {
  width: calc(100% - 130px);
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

/* 只读字段样式 */
input[readonly], textarea[readonly] {
  background-color: #f9f9f9;
  color: #666;
  cursor: not-allowed;
}

textarea {
  min-height: 80px;
  resize: vertical;
}

.items-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.items-table th, .items-table td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
}

.items-table th {
  background-color: #f8f9fa;
  font-weight: bold;
  color: #333;
}

.items-table tr:hover {
  background-color: #f8f9fa;
}

.items-table input {
  width: 80px;
}

/* 总计样式 */
.total-row {
  background-color: #f0f7ff;
}

.grand-total {
  font-weight: bold;
  color: #007bff;
}

/* 状态标签样式 */
.status-tag {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  color: white;
}

.status-tag.matched {
  background-color: #28a745; /* 绿色 - 已匹配 */
}

.status-tag.unmatched {
  background-color: #dc3545; /* 红色 - 未匹配 */
}

/* 操作列样式调整 */
.items-table td:last-child {
  white-space: nowrap;
}
</style>
